import * as React from "react";
import { SVGProps } from "react";
const SvgGy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 100 60"
    {...props}
  >
    <defs>
      <clipPath id="gy_svg__a">
        <path d="m0 0 100 30L0 60z" />
      </clipPath>
      <clipPath id="gy_svg__b">
        <path d="m0 0 50 30L0 60z" />
      </clipPath>
    </defs>
    <path fill="#009e49" d="M0 0h100v60H0z" />
    <path
      clipPath="url(#gy_svg__a)"
      fill="#fcd116"
      stroke="#fff"
      strokeWidth={4}
      d="m0 0 100 30L0 60"
    />
    <path
      clipPath="url(#gy_svg__b)"
      fill="#ce1126"
      stroke="#000"
      strokeWidth={6}
      d="m0 0 50 30L0 60"
    />
  </svg>
);
export default SvgGy;
